import { Router } from '@angular/router';
import { AppService } from './../services/app.service';
import { Component, ViewChild, OnInit } from '@angular/core';
import { TableSetting } from 'projects/Shared-Lib/component/table/table-class';
import { ReturnClass } from 'projects/Shared-Lib/model/search-result';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { FilterDataService } from '../services/filter-data.service';
import { AuthUser, AuthUser_Search } from '../model/auth-user';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';

@Component({
  selector: 'app-auth-user',
  templateUrl: './auth-user.component.html',
  styleUrls: ['./auth-user.component.css']
})
export class AuthUserComponent {
  @ViewChild('acc') acc: NgbAccordionItem;

  ControllerName: string = 'AuthUser';
  model: AuthUser_Search;
  CanCreate: boolean = false;
  TableData: ReturnClass;
  TableSetting: TableSetting;
  userPermission: any;
  currentRoute: string;

  constructor(private app: AppService, private dataSer: DataService,
    private DlgService: DialogService, private router: Router, private filterService: FilterDataService) {
    this.model = new AuthUser_Search();
    this.TableSetting = new TableSetting();
    this.TableSetting.CanUpdate = true;
    this.TableSetting.CanDelete = true;
    this.TableSetting.IdColumnName = 'UserID';
    this.TableSetting.ItemTitle = (item: AuthUser) => {
      return `[${item.UserID}]${item.UserName}`;
    };
    this.TableSetting.CorrespondTableHeard = [
      { columnDef: 'UserAccount', header: 'User Account', cell: (element: AuthUser) => `${element.UserAccount}` },
      { columnDef: 'UserName', header: 'User Name', cell: (element: AuthUser) => `${element.UserName}` },
      { columnDef: 'EMail', header: 'Email', cell: (element: AuthUser) => `${element.EMail}` },
      { columnDef: 'UserType', header: 'User Type', cell: (element: AuthUser) => element.UserType === 1 ? 'Internal' : element.UserType === 2 ? 'External' : '' },
      { columnDef: 'UpdatedBy', header: 'Update User', cell: (element: AuthUser) => `${element.UpdatedBy == null ? '' : element.UpdatedBy}` },
      { columnDef: 'UpdatedDateTime', header: 'Update Date', cell: (element: AuthUser) => `${element.UpdatedDateTime == null ? '' : element.UpdatedDateTime.ToDateTimeString()}` }
    ];

    this.userPermission = this.app.currentResource.subscribe(data => {
      this.TableSetting.CanUpdate = false;
      this.TableSetting.CanDelete = data.CanDelete;
      this.CanCreate = data.CanCreate;
    })
  }
  ngOnInit() {
    setTimeout(() => this.app.SetLoadingState(true), 0);
    this.currentRoute = this.router.url;
    this.Search();
  }

  Search() {
    if (this.filterService.HasUsed) {
      let LasttimeSearchInfo = this.filterService.GetSearchInfo();
      if (LasttimeSearchInfo.Filter) {
        this.model.filter = LasttimeSearchInfo.Filter;
      }
    }
    this.filterService.ChangeSearchInfo(this.currentRoute, this.model.filter);

    this.dataSer.getData(this.ControllerName + '/List', this.model.filter, (ret) => {
      console.log('Data fetched successfully:', ret);
      this.TableData = {
        draw: this.model.filter.PageIndex,
        pagingSize: this.model.filter.PageSize,
        recordsTotal: ret.TotalCount,
        recordsFiltered: ret.TotalCount,
        data: ret.DataList
      };
    }, (err) => {
      console.error('Error fetching data:', err);
    }, () => {
      setTimeout(() => this.app.SetLoadingState(false), 0);
    });
  }

  Delete(DeleteItem: any) {
    this.app.SetLoadingState(true);
    this.dataSer.DeleteData(`${this.ControllerName}/${DeleteItem.UserID}`, null,
      (res) => {
        this.Search();
      },
      (res) => {
        let result = this.DlgService.ErrorInformation(res.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      },
      () => {
        this.app.SetLoadingState(false);
      }
    );
  }

  onChangePageInfo(PageInfo: any) {
    this.model.filter.PageSize = PageInfo.PageSize;
    this.model.filter.PageIndex = PageInfo.CurrentPage;

    this.Search();
  }
  onChangeTableInfo(TableInfo: any) {
    this.model.filter.SortBy = TableInfo.SortBy;
    this.model.filter.IsAsc = TableInfo.IsAsc;

    this.Search();
  }
}
